import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Apollo } from 'apollo-angular';
import { firstValueFrom, Observable } from 'rxjs';
import { getFullStrategies, getStrategy } from './query';

export class Estrategias {
  public objectiveIds?: Number[];
  public name?: String;
  public id?: Number;
}

@Injectable({
  providedIn: 'root'
})
export class StrategiaService {
  private apiURL = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private readonly cookies: CookieService,
    private readonly http: HttpClient,
    private readonly apollo: Apollo,
  ) { }

  async getStrategyGQL(id: string[]){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
        query: getStrategy,
        context: {headers: this.headers},
        variables: {
          "args": {
            "filter": {
              "conditions": [
                {
                  "field": "id",
                  "operator": "IN",
                  "value": id
                }
              ]
            }
          }
        },
        fetchPolicy: 'no-cache'
      }).valueChanges
    );
    return data.searchStrategies.data;
  }

  async getStrategyGQLFull(id: string[]){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
        query: getFullStrategies,
        context: {headers: this.headers},
        variables: {
          "args": {
            "filter": {
              "conditions": [
                {
                  "field": "id",
                  "operator": "IN",
                  "value": id
                }
              ]
            }
          }
        },
        fetchPolicy: 'no-cache'
      }).valueChanges
    );
    return data.searchStrategies.data;
  }

  public postEstrategias(estr: any): Observable<any> {
    const estrategi: Estrategias = {
      objectiveIds: estr.objetiveId,
      name: estr.name
    }
    const body = JSON.stringify(estrategi);
    const apiURL = this.apiURL + "estrategia";
    return this.http.post(`${apiURL}`, body, { headers: this.headers });
  }

  public patchEstrategia(estr: any): Observable<any> {
    const estrategi: Estrategias = {
      objectiveIds: estr.objetiveId,
      name: estr.name,
    }
    const body = JSON.stringify(estrategi);
    const apiURL = this.apiURL + "estrategia/" + estr.id;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }
  public deleteEstrategias(estr: any): Observable<any> {
      const apiURL = this.apiURL + "estrategia/" + estr.id;
      return this.http.delete(`${apiURL}`, { headers: this.headers });
    }
}
